declare namespace $ {

	type $shm_ba_date__period_shm_wordstat_filter_panel_1 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['period'] >
		,
		ReturnType< $shm_ba_date['period'] >
	>
	type $shm_ba_date__period_all_shm_wordstat_filter_panel_2 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['period_all'] >
		,
		ReturnType< $shm_ba_date['period_all'] >
	>
	type $shm_wordstat_filter_section__title_content_shm_wordstat_filter_panel_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_wordstat_filter_section['title_content'] >
	>
	type $shm_wordstat_filter_section__Expand_shm_wordstat_filter_panel_4 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_wordstat_filter_section['Expand'] >
	>
	type $shm_wordstat_filter_section__content_shm_wordstat_filter_panel_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_wordstat_filter_section['content'] >
	>
	type $mol_check_box__title_shm_wordstat_filter_panel_6 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['period_kind_title'] >
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_wordstat_filter_panel_7 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['period_kind_checked'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__enabled_shm_wordstat_filter_panel_8 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['period_kind_enabled'] >
		,
		ReturnType< $mol_check_box['enabled'] >
	>
	type $shm_radio__title_shm_wordstat_filter_panel_9 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['period_kind_title'] >
		,
		ReturnType< $shm_radio['title'] >
	>
	type $shm_radio__checked_shm_wordstat_filter_panel_10 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['period_kind_checked'] >
		,
		ReturnType< $shm_radio['checked'] >
	>
	type $shm_radio__enabled_shm_wordstat_filter_panel_11 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['period_kind_enabled'] >
		,
		ReturnType< $shm_radio['enabled'] >
	>
	type $mol_view__sub_shm_wordstat_filter_panel_12 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['period_kind_check_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_wordstat_filter_section__title_shm_wordstat_filter_panel_13 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_wordstat_filter_section['title'] >
	>
	type $shm_wordstat_filter_section__Expand_shm_wordstat_filter_panel_14 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_wordstat_filter_section['Expand'] >
	>
	type $shm_wordstat_filter_section__content_shm_wordstat_filter_panel_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_wordstat_filter_section['content'] >
	>
	type $mol_view__sub_shm_wordstat_filter_panel_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_wordstat_filter_panel_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_check_all__checks_shm_wordstat_filter_panel_18 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['query_group_checks'] >
		,
		ReturnType< $shm_check_all['checks'] >
	>
	type $shm_check_all__title_shm_wordstat_filter_panel_19 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_check_all['title'] >
	>
	type $mol_textarea__hint_shm_wordstat_filter_panel_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_textarea__value_shm_wordstat_filter_panel_21 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['queries'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__event_shm_wordstat_filter_panel_22 = $mol_type_enforce<
		({ 
			focusout( next?: ReturnType< $shm_wordstat_filter_panel['queries_blur'] > ): ReturnType< $shm_wordstat_filter_panel['queries_blur'] >,
		})  & ReturnType< $mol_textarea['event'] >
		,
		ReturnType< $mol_textarea['event'] >
	>
	type $mol_view__sub_shm_wordstat_filter_panel_23 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['query_row_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_wordstat_filter_panel_24 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['query_check_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_wordstat_filter_section__title_content_shm_wordstat_filter_panel_25 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['query_title_content'] >
		,
		ReturnType< $shm_wordstat_filter_section['title_content'] >
	>
	type $shm_wordstat_filter_section__Expand_shm_wordstat_filter_panel_26 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_wordstat_filter_section['Expand'] >
	>
	type $shm_wordstat_filter_section__content_shm_wordstat_filter_panel_27 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['query_content'] >
		,
		ReturnType< $shm_wordstat_filter_section['content'] >
	>
	type $mol_view__sub_shm_wordstat_filter_panel_28 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_check_all__checks_shm_wordstat_filter_panel_29 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['device_group_checks'] >
		,
		ReturnType< $shm_check_all['checks'] >
	>
	type $shm_check_all__title_shm_wordstat_filter_panel_30 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_check_all['title'] >
	>
	type $mol_check_box__title_shm_wordstat_filter_panel_31 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_wordstat_filter_panel_32 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['device_all'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__enabled_shm_wordstat_filter_panel_33 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['device_all_enabled'] >
		,
		ReturnType< $mol_check_box['enabled'] >
	>
	type $mol_check_box__title_shm_wordstat_filter_panel_34 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_wordstat_filter_panel_35 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['device_desktop'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__enabled_shm_wordstat_filter_panel_36 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['device_desktop_enabled'] >
		,
		ReturnType< $mol_check_box['enabled'] >
	>
	type $mol_check_box__title_shm_wordstat_filter_panel_37 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_wordstat_filter_panel_38 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['device_phone'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__enabled_shm_wordstat_filter_panel_39 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['device_phone_enabled'] >
		,
		ReturnType< $mol_check_box['enabled'] >
	>
	type $mol_check_box__title_shm_wordstat_filter_panel_40 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_wordstat_filter_panel_41 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['device_tablet'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_check_box__enabled_shm_wordstat_filter_panel_42 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['device_tablet_enabled'] >
		,
		ReturnType< $mol_check_box['enabled'] >
	>
	type $mol_view__sub_shm_wordstat_filter_panel_43 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_wordstat_filter_section__title_content_shm_wordstat_filter_panel_44 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_wordstat_filter_section['title_content'] >
	>
	type $shm_wordstat_filter_section__Expand_shm_wordstat_filter_panel_45 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_wordstat_filter_section['Expand'] >
	>
	type $shm_wordstat_filter_section__content_shm_wordstat_filter_panel_46 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_wordstat_filter_section['content'] >
	>
	type $shm_wordstat_region_select__regions_shm_wordstat_filter_panel_47 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['regions'] >
		,
		ReturnType< $shm_wordstat_region_select['regions'] >
	>
	type $shm_wordstat_region_select__allowed_ids_shm_wordstat_filter_panel_48 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['region_available'] >
		,
		ReturnType< $shm_wordstat_region_select['allowed_ids'] >
	>
	type $shm_wordstat_region_select__presets_visible_shm_wordstat_filter_panel_49 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_wordstat_region_select['presets_visible'] >
	>
	type $mol_list__rows_shm_wordstat_filter_panel_50 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['filter_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_button_major__enabled_shm_wordstat_filter_panel_51 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['run_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__title_shm_wordstat_filter_panel_52 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['run_title'] >
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_wordstat_filter_panel_53 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['run'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__style_shm_wordstat_filter_panel_54 = $mol_type_enforce<
		({ 
			'color': ReturnType< $shm_wordstat_filter_panel['run_color'] >,
		})  & ReturnType< $mol_button_major['style'] >
		,
		ReturnType< $mol_button_major['style'] >
	>
	type $mol_check_box__title_shm_wordstat_filter_panel_55 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['query_title'] >
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_wordstat_filter_panel_56 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['query_checked'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_button_minor__title_shm_wordstat_filter_panel_57 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_wordstat_filter_panel_58 = $mol_type_enforce<
		ReturnType< $shm_wordstat_filter_panel['query_only'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	export class $shm_wordstat_filter_panel extends $shm_service_filter_panel {
		panel_title( ): string
		filter_reset( next?: any ): any
		Period_icon( ): $mol_icon_calendar
		Period( ): $shm_ba_date
		Period_section( ): $shm_wordstat_filter_section
		period_kind_title( id: any): string
		period_kind_checked( id: any, next?: boolean ): boolean
		period_kind_enabled( id: any): boolean
		Period_kind_check( id: any): $mol_check_box
		Period_kind_radio( id: any): $shm_radio
		period_kind_check_rows( ): readonly(any)[]
		Period_kinds( ): $mol_view
		Period_kind_section( ): $shm_wordstat_filter_section
		Query_title( ): $mol_view
		query_hint( ): string
		Query_hint( ): $mol_view
		query_group_checks( ): readonly(any)[]
		Query_all( ): $shm_check_all
		query_title_content( ): readonly(any)[]
		Queries( ): $mol_textarea
		query_row_content( id: any): readonly(any)[]
		Query_row( id: any): $mol_view
		query_check_rows( ): readonly(any)[]
		Query_checks( ): $mol_view
		query_content( ): readonly(any)[]
		Query_section( ): $shm_wordstat_filter_section
		Device_title( ): $mol_view
		device_group_checks( ): readonly(any)[]
		Device_group_all( ): $shm_check_all
		device_all( next?: boolean ): boolean
		device_all_enabled( ): boolean
		Device_all( ): $mol_check_box
		device_desktop( next?: boolean ): boolean
		device_desktop_enabled( ): boolean
		Device_desktop( ): $mol_check_box
		device_phone( next?: boolean ): boolean
		device_phone_enabled( ): boolean
		Device_phone( ): $mol_check_box
		device_tablet( next?: boolean ): boolean
		device_tablet_enabled( ): boolean
		Device_tablet( ): $mol_check_box
		Devices( ): $mol_view
		Devices_section( ): $shm_wordstat_filter_section
		region_available( ): readonly(any)[]
		Region_select( ): $shm_wordstat_region_select
		filter_rows( ): readonly(any)[]
		Filters( ): $mol_list
		run( next?: any ): any
		Run( ): $mol_button_major
		foot_rows( ): readonly(any)[]
		query_title( id: any): string
		query_checked( id: any, next?: boolean ): boolean
		query_only( id: any, next?: any ): any
		state( ): $shm_wordstat_filter_state_store | null
		queries( next?: string ): string
		queries_blur( next?: any ): any
		query_filter( next?: Record<string, any> ): Record<string, any>
		query_available( ): readonly(any)[]
		query_limit( ): number
		regions( next?: string ): string
		period_kind( next?: string ): string
		period_kinds( next?: Record<string, any> ): Record<string, any>
		period_kind_available( ): readonly(any)[]
		devices( next?: Record<string, any> ): Record<string, any>
		device_available( ): readonly(any)[]
		period( next?: ({ 
			'from': string,
			'to': string,
		})  ): ({ 
			'from': string,
			'to': string,
		}) 
		period_all( ): ({ 
			'from': string,
			'to': string,
		}) 
		period_all_kind( id: any): ReturnType< $shm_wordstat_filter_panel['period_all'] >
		collecting( ): boolean
		query_visible( ): boolean
		period_kind_visible( ): boolean
		device_visible( ): boolean
		region_visible( ): boolean
		run_enabled( ): boolean
		run_title( ): string
		run_color( ): string
		cancel_visible( ): boolean
		title( ): ReturnType< $shm_wordstat_filter_panel['panel_title'] >
		reset( next?: ReturnType< $shm_wordstat_filter_panel['filter_reset'] > ): ReturnType< $shm_wordstat_filter_panel['filter_reset'] >
		body( ): readonly(any)[]
		foot( ): ReturnType< $shm_wordstat_filter_panel['foot_rows'] >
		Query_check( id: any): $mol_check_box
		Query_only( id: any): $mol_button_minor
	}
	
}

//# sourceMappingURL=panel.view.tree.d.ts.map